<template>
  <div class="content">
    <s-location mypage title="비밀번호 변경"/>
    <div class="al_c">
        <table class="tbl01 cont_w800 " >
          <tr>
            <th style="width:250px;">
              기존 비밀번호
            </th>
            <td style="text-align:left;">
              <input v-model="item.pw"   ref="pw"       type="password" title="기존 비밀번호 입력" placeholder="기존 비밀번호 입력" @keydown.enter="doChange" maxlength="16"/>
              <div class="input-error" v-if="inputError.pw">{{ inputError.pw }}</div>
            </td>
          </tr>
          <tr>
            <th>
              새 비밀번호
            </th>
            <td style="text-align:left;">
              <input v-model="item.pw_new"          type="password" title="새 비밀번호 입력" placeholder="새 비밀번호 입력" @keydown.enter="doChange" maxlength="16"/>
              <div class="input-error" v-if="inputError.pw_new">{{ inputError.pw_new }}</div>
            </td>
          </tr>
          <tr>
            <th>
              새 비밀번호 확인
            </th>
            <td style="text-align:left;">
              <input v-model="item.pw_newchk"       type="password" title="새 비밀번호 확인" placeholder="새 비밀번호 확인" @keydown.enter="doChange" maxlength="16"/>
              <div class="input-error" v-if="inputError.pw_newchk">{{ inputError.pw_newchk }}</div>
            </td>
          </tr>
        </table>
    </div>
    <div class="btn_group right btn blue01" style="max-width:200px;" @click="doChange">비밀번호 변경</div>
  </div>
</template>

<script>
let ui
export default {
  created() {
    ui = this.$ui;
  },
  mounted() {
    this.$refs.pw.focus()
  },
  data() {
    return {
      item: {
        id : this.$store.state.session.user.id,
        pw: '',
        pw_new: '',
        pw_newchk: '',
      },
      inputError: {pw : '',  pw_new : '', pw_newchk : ''},
    }
  },
  watch: {
    "item.pw"(v) { this.inputError.pw = this.checkInput('pw', v) },
    "item.pw_new"(v) { this.inputError.pw_new = this.checkInput('pw_new', v) },
    "item.pw_newchk"(v) { this.inputError.pw_newchk = this.checkInput('pw_newchk', v) },
  },
  methods: {
    checkInput(kind, v) {
      if (_.isEmpty(v)) return ""

      switch(kind) {
        case "pw":
          if(v.length < 3) return "3자 이상 입력하세요."
          return ""
        case "pw_new":
          if (!/^[\da-zA-Z$@$!%*?&\\.]{8,16}$/.test(v)) return "8~16자 영문 대 소문자, 숫자 2자 이상, 특수문자 1자 이상을 입력해 주세요"
          if (!/\d/.test(v)) return "숫자 1자 이상을 입력해 주세요"
          if (!/[$@$!%*?&\\.]/.test(v)) return "특수문자 1자 이상을 입력해 주세요"
          return ""
        case "pw_newchk":
          if (this.item.pw_new != v) return "비밀번호와 비밀번호 확인이 일치하지 않습니다."
          return ""
      }
    },

    doChange() {

      if (this.inputError.pw.length != 0 || this.inputError.pw_new.length != 0 || this.inputError.pw_newchk.length != 0 || !this.item.pw || !this.item.pw_new || !this.item.pw_newchk){
        ui.alert("비밀번호 형식에 맞게 입력해주세요.")
        return
      }

      // 비밀번호 업데이트
      ui.httpGet('/mypage/pw_change',
      {
        id : this.item.id,
        pw : this.item.pw,
        pw_new : this.item.pw_new
      },
      ret => {
        const { msg, status } = ret.data

        console.log("mag : " + msg);
        console.log("status : " + status);

        if (status == '0'){
          ui.alert(msg)
        } else {
          ui.alert_error(msg)
        }

        this.item = {pw : '',  pw_new : '', pw_newchk : ''}

      })

    }
  },
}
</script>
<style scoped>

  /*-----------------------------------------------------------------------------------------------
    LOGIN :: 로그인
  -------------------------------------------------------------------------------------------------*/
  .login_wrap { display: inline-block; width: 100%; max-width: 480px; margin: 50px auto 20px auto; position:relative; padding: 35px 45px; border: 1px solid #e5e5e5; font-size: 16px; vertical-align: top; box-sizing: border-box; text-align: left; }
  .login_wrap h3 { font-size : 18px;  margin-bottom:40px;}
  .login_wrap h3 p{ color:#064680; margin-top:10px; font-size: 22px;}
  .login_wrap input[type="text"], .login_wrap input[type="password"]{ width: 100%; height: 48px; padding: 11px 70px 11px 11px; font-size:16px; font-weight:700; box-sizing: border-box; background-color: #f3f3f3; margin-bottom:10px; }
  .login_wrap .btn { margin:40px 0 5px 0;}
  .info_user { font-size:13px;}

  .sel_mem li { width:30%; padding: 15px; font-size:14px;}
  .sel_mem li .tit{font-size:15px;}

  .sel_mem li .cont { font-size:14px; font-weight: normal}

  .input-error { color: red; margin-top: 7px;  }


</style>